module.exports = __webpack_public_path__ + "static/media/favIcon.53ee2ace.svg";